import { render, staticRenderFns } from "./TourAttentionAlert.vue?vue&type=template&id=1f8a4af0&"
import script from "./TourAttentionAlert.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TourAttentionAlert.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TourAttentionAlert.vue?vue&type=style&index=0&id=1f8a4af0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports